import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCroatia = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 512 512",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#f0f0f0",
			d: "M512 256c0-31.3-5.6-61.3-16-89l-240-11.2L16 167a255.5 255.5 0 0 0 0 178l240 11.2L496 345c10.4-27.7 16-57.7 16-89z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M256 512a256 256 0 0 0 240-167H16a256 256 0 0 0 240 167z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#d80027",
			d: "M16 167h480a256 256 0 0 0-480 0z"
		}),
		/* @__PURE__ */ _jsx("g", {
			fill: "#338af3",
			children: /* @__PURE__ */ _jsx("path", { d: "M322.8 178h-44.5l7.4-55.6 29.7-22.2 29.6 22.2V167zM189.2 178h44.5l-7.4-55.6-29.7-22.2-29.6 22.2V167z" })
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0052b4",
			d: "M285.7 178h-59.4v-55.6l29.7-22.2 29.7 22.2z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#f0f0f0",
			d: "M167 167v122.4a89 89 0 0 0 35.8 71.3l15.5-3.9 19.7 19.8a89.1 89.1 0 0 0 35.9 0l22.4-18.7 13 2.8a89 89 0 0 0 35.7-71.3V167z"
		}),
		/* @__PURE__ */ _jsxs("g", {
			fill: "#d80027",
			children: [/* @__PURE__ */ _jsx("path", { d: "M167 167h35.6v35.6H167zM238.2 167h35.6v35.6h-35.6zM309.4 167H345v35.6h-35.6zM202.6 202.6h35.6v35.6h-35.6zM273.8 202.6h35.6v35.6h-35.6zM167 238.2h35.6v35.6H167zM202.6 273.8h35.6v35.6h-35.6zM238.2 238.2h35.6v35.6h-35.6zM309.4 238.2H345v35.6h-35.6zM273.8 273.8h35.6v35.6h-35.6zM238.2 309.4h35.6V345h-35.6z" }), /* @__PURE__ */ _jsx("path", { d: "M202.6 309.4h-33.3c3 13.3 9 25.4 17.3 35.6h16zM309.4 345h16a88.7 88.7 0 0 0 17.3-35.6h-33.3zM202.6 345v15.6a88.7 88.7 0 0 0 35.6 16V345zM273.8 345v31.6a88.7 88.7 0 0 0 35.6-16V345z" })]
		})
	]
});
export default SvgCroatia;
